import React from "react"
import Grid from '@mui/material/Grid'
import SimpleTextField from "../../../../../components/Forms/SimpleTextField"

const BGL = ({ value, onChange }) => (
    <Grid item xs={12} md={6} lg={4} xl={3}>
      <SimpleTextField
        value={value}
        onChange={onChange}
        label="Blood Glucose Level"
        type="number"
        InputProps={{
          inputProps: { min: 0, max: 40, step: 'any' },
          endAdornment: 'mmol/L',
        }}
      />
    </Grid>
  )

  export default BGL